import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	indexStaffMembersDocumentLinks,
} from "~/modules/humanResources/api/staffMemberDocumentLink/staffMemberDocumentLinkApiDispatchers.ts";

export const STAFF_MEMBER_DOCUMENT_LINK_BASE_QUERY_KEY = "staffMembersDocumentLinks";

export const STAFF_MEMBERS_DOCUMENT_LINKS_QUERY_KEY = (staffMemberId: string) => [STAFF_MEMBER_DOCUMENT_LINK_BASE_QUERY_KEY, staffMemberId];

export const useStaffMembersDocumentLinks = (staffMemberId:string) => useQuery({
    queryKey: STAFF_MEMBERS_DOCUMENT_LINKS_QUERY_KEY(staffMemberId),
    queryFn: () => indexStaffMembersDocumentLinks(staffMemberId).then(getDataFromResponse),
	enabled: !!staffMemberId,
});